import { PlanBoxContext } from "@/components/molecules/PlanBox";
import { PlanBoxFooter } from "@/components/atoms/PlanBoxFooter";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { format, lastDayOfMonth } from "date-fns";
import React, { useContext } from "react";

export const PlanBoxFooterCancelPlan = () => {
  const { now } = useContext(PlanBoxContext);

  const lastDayOfThisMonth = format(lastDayOfMonth(now), "yyyy/MM/dd");

  return (
    <PlanBoxFooter>
      <div css={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Font>解約日</Font>
        <Font variant="lb">{lastDayOfThisMonth}</Font>
      </div>
    </PlanBoxFooter>
  );
};
